import gsap from 'gsap';

import Sakura from '../common/sakura/sakura';


export default class Intro{

    constructor() {
        this._init();
    }

    start(){
        this._startAnime();
    }

    _init(){
        this.sakura = new Sakura();
        this._initAnime();
    }


    _initAnime(){        
        gsap.set('.top__title', {opacity:0, scale:1.15});
        gsap.set('.top__rainbow', {opacity:0});
        gsap.set('.top__btnlist__item', {opacity:0, y:20});
    }


    _startAnime(){
        this.tl = gsap.timeline();
        this.tl
            .add(this._showHeader.bind(this), '+=0.5')
            .add(this._showItem.bind(this), '+=0.5');

        this.sakura.render();
    }

    _showHeader(){
        gsap.to('.top__title', {duration:0.35, opacity:1, scale:1, ease:'back.out(1)'});
        gsap.to('.top__rainbow', {duration:0.35, opacity:1, ease:'power2.easeOut'});
    }

    _showItem(){
        gsap.to('.top__btnlist__item', {duration:0.5, delay:0.2, opacity:1, y:0, ease:'power2.out', stagger:0.2});
    }
}
